import { IPaginator } from './paginator';

export interface ILicenceAuthorityFormValues {
  name: string;
  isActive: boolean | string;
  signatureAttachmentFile: File | null;
  authorizedPersonName: string;
  position: string;
}
export interface ILicenceAuthorityPrintoutSettings {
  uniqueId: string;
  host: string;
  port: string;
  username: string;
  hostFingerprints: string[];
  pgpForeignPublicKey: string;
  sshOwnPublicKey: string;
  pgpOwnPublicKey: string;
  outboundPath: string;
  inboundPath: string;
  sendHours: number[];
  version: number;
}
export interface ILicenceAuthorityPrintoutSettingsFormValues {
  username: string;
  host: string;
  port: string;
  hostFingerprints: string[];
  pgpPublicKey: string;
  outboundPath: string;
  inboundPath: string;
  sendHours: number[];
}
export interface ILicenceAuthority {
  uniqueId: string;
  dictionaryUniqueId: string;
  name: string;
  isActive: boolean;
  authorizedPersonName: string;
  position: string;
  signatureAttachmentUniqueId: string;
  signatureAttachmentUrl: string;
  signatureAttachmentType: string;
  signatureAttachmentName: string;
}
export interface ILicenceAuthorityResponse extends IPaginator {
  content: ILicenceAuthority[];
}
export interface LicenceAuthoritySftpConfigDeletionInfoResponse {
  hasWaitingPrintRequests: boolean;
}

export interface ILicenceAuthorityPrintoutErrorLogResponse extends IPaginator {
  content: ILicenceAuthorityPrintoutErrorLog[];
}

export interface ILicenceAuthorityPrintoutErrorLog {
  uniqueId: string;
  type: ELicenceAuthorityPrintoutErrorLogType;
  messageKey: string;
  detail?: string;
  batchUniqueId?: string;
  batchName?: string;
  status: ELicenceAuthorityPrintoutErrorLogStatus;
  firstSeen: string;
  lastSeen: string;
  occurrenceCount: number;
}

export enum ELicenceAuthorityPrintoutErrorLogStatus {
  ACTIVE = 'ACTIVE',
  RESOLVED = 'RESOLVED',
}

export enum ELicenceAuthorityPrintoutErrorLogType {
  CONFIG_INCOMPLETE = 'CONFIG_INCOMPLETE',
  SECRET_MISSING = 'SECRET_MISSING',
  UPLOAD_FAILED = 'UPLOAD_FAILED',
  MANIFEST_POLL_FAILED = 'MANIFEST_POLL_FAILED',
  UNKNOWN_INBOUND_FILE = 'UNKNOWN_INBOUND_FILE',
  MANIFEST_REJECTED = 'MANIFEST_REJECTED',
  MANIFEST_RESULT_MISMATCH = 'MANIFEST_RESULT_MISMATCH',
  AUTHORITY_PAUSED = 'AUTHORITY_PAUSED',
  BATCH_STUCK = 'BATCH_STUCK',
}

export enum ELicenceAuthoritySftpAlertCategory {
  OK = 'OK',
  MANIFEST_FAILING = 'MANIFEST_FAILING',
  SENDING_FAILING = 'SENDING_FAILING',
  SENDING_BLOCKED_CONFIG = 'SENDING_BLOCKED_CONFIG',
  SENDING_PAUSED = 'SENDING_PAUSED',
}

export interface ILicenceAuthoritySftpAlertStatus {
  category: ELicenceAuthoritySftpAlertCategory;
  messageKey: string | null;
  since: string | null;
}

export interface ILicenceAuthoritySendState {
  paused: boolean;
}
